'use client';

// Navegación lateral del panel (design-system §5.1):
//   - 768–1279 px: riel de iconos con la etiqueta corta debajo;
//   - >= 1280 px: sidebar oscuro con marca y etiquetas completas (maqueta 04).
// En móvil (< 768 px) se oculta: allí navega la barra de pestañas inferior.
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '@vendedor/ui';
import { getSidebarItems, isNavItemActive } from '@/lib/navigation';
import { NavIcon } from './nav-icon';

const items = getSidebarItems();

export function SideNav() {
  const pathname = usePathname();

  return (
    <aside
      aria-label="Navegación principal"
      className={cn(
        'sticky top-0 hidden h-dvh shrink-0 flex-col overflow-y-auto bg-sidebar-bg text-sidebar-fg',
        // Riel (tablet).
        'md:flex md:w-[92px] md:px-2 md:pt-[calc(--spacing(6)+env(safe-area-inset-top))] md:pb-[calc(--spacing(6)+env(safe-area-inset-bottom))] md:pl-[calc(--spacing(2)+env(safe-area-inset-left))]',
        // Sidebar (escritorio, maqueta 04: 232 px, relleno 28/18).
        'xl:w-[232px] xl:px-4.5 xl:pt-[calc(--spacing(7)+env(safe-area-inset-top))] xl:pl-[calc(--spacing(4.5)+env(safe-area-inset-left))]',
      )}
    >
      {/* Marca: solo en escritorio; el riel muestra únicamente la navegación. */}
      <div className="mb-5.5 hidden font-display text-2xl leading-tight font-bold text-sidebar-fg-active xl:block">
        [TU MARCA]
      </div>

      <nav aria-label="Secciones del panel">
        <ul className="m-0 flex list-none flex-col gap-1.5 p-0">
          {items.map((item) => {
            const active = isNavItemActive(pathname, item.href);
            return (
              <li key={item.id}>
                <Link
                  href={item.href}
                  aria-current={active ? 'page' : undefined}
                  className={cn(
                    'flex min-h-touch flex-col items-center justify-center gap-1 rounded-md px-1 py-2 text-center text-xs no-underline',
                    'transition-colors duration-(--motion-fast) ease-standard',
                    'xl:flex-row xl:justify-start xl:gap-3 xl:px-3.5 xl:py-0 xl:text-left xl:text-base',
                    'focus-visible:shadow-focus focus-visible:outline-none',
                    active
                      ? 'bg-sidebar-item-active font-bold text-sidebar-fg-active'
                      : 'font-normal text-sidebar-fg hover:bg-sidebar-item-active hover:text-sidebar-fg-active',
                  )}
                >
                  <NavIcon name={item.icon} />
                  <span className="xl:hidden">{item.shortLabel}</span>
                  <span className="hidden xl:inline">{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
}
